<template>
  <div class="home">
    <!--  导航  -->
    <div class="home_head">
      <div class="home_head_box">
        <div class="home_head_box_log">
          <img src="@/assets/images/logo@2x.png" alt="" />
          <span>上海澜启信息科技有限公司</span>
        </div>
        <div class="home_head_box_menu">
          <div :class="index === i ? 'home_head_box_menu_row home_head_box_menu_active' : 'home_head_box_menu_row'" v-for="(item, index) in list" :key="index" @click="clickItem(item, index)">{{item.name}}</div>
        </div>
      </div>
    </div>
    <!--  banner  -->
    <div class="home_banner">
      <div class="home_banner_box">
        <div class="home_banner_box_left">
          <span>All About You.</span>
          <el-button type="primary" color="#155FFE" style="margin-top: 57px; width: 180px; height: 82px; font-size: 26px; letter-spacing: 7px;">了解更多</el-button>
        </div>
        <div class="home_banner_box_right">
          <img src="@/assets/images/banner@2x.png" alt="" />
        </div>
      </div>
    </div>
    <!--  产品介绍  -->
    <div class="home_product" ref="dom1">
      <div class="home_product_box">
        <div class="title">产品介绍</div>
        <div class="home_product_box_list">
          <div class="item">
            <div class="item_box">
              <div class="item_box_file">
                <video src="@/assets/test.mp4" muted loop controls></video>
              </div>
              <div class="item_box_title">
                <span>百科体育</span>
                <span>BAKER SPORT</span>
              </div>
              <div class="item_box_info">
                低成本可穿戴设备+信号数字建模算法
                =职业比赛昂贵视频图像处理系统, 用于
                运动过程中动作和生理数据记录和分析，
                让普通运动爱好者也能享受顶级职业球
                员才能拥有的待遇 ——用专业级的数据
                提高运动水平，记录成长历程。
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item_box">
              <div class="item_box_file">
                <img src="@/assets/images/123.png" alt="" />
              </div>
              <div class="item_box_title">
                <span>Ai赋能银发经济</span>
                <span>智慧养老院一体化解决方</span>
              </div>
              <div class="item_box_info">
                强化老年用品创新，打造智慧健康养老新业态，推广应用智能护理机器人、家庭服务机器人，大力发展康复辅助器具产业。 发展抗衰老产业，推动生物技术与延缓老年病深度融合，开发老年病早期筛查产品和服务。 组建覆盖全国的旅居养老产业合作平台，培育旅居养老目的地。
              </div>
            </div>
          </div>
          <div class="item">
            <div class="item_box">
              <div class="item_box_file">
                <img src="@/assets/images/748.png" alt="" />
              </div>
              <div class="item_box_title">
                <span>增强现实试衣舱</span>
                <span>Ai垂直大模型、时尚内容平台</span>
              </div>
              <div class="item_box_info">
                以增强现实试衣舱和时尚Ai垂直大模型为技术支撑，时尚内容平台为最终定位，来连接品牌形象/设计理念和用户。
                让每一个对美感有追求的人都能低门槛低成本生成高质量作品
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!--  底层技术支持  -->
    <div class="home_hz">
      <div class="home_hz_box" ref="dom2">
        <div class="home_hz_box_title">底层技术支持</div>
        <div class="home_hz_box_list">
          <el-carousel indicator-position="outside" height="800px" :autoplay="false" ref="carousel">
            <el-carousel-item @mousedown="mousedown" :style="autoplay?'':'transition: none;'">
              <div class="list">
                <div class="list_item">
                  <div class="list_item_icon">
                    <img src="@/assets/images/1.png" draggable="false" />
                  </div>
                  <div class="list_item_title">机器视觉和大数据分析系统</div>
                  <div class="list_item_info">
                    通过对图像深度学习算法实现机器视觉和大数据分析，系统可广泛应用于各种工业和生活场景，辅助提高生产效率、品质监控、场景分析，提升生产生活智能化水平。
                  </div>
                </div>
                <div class="list_item">
                  <div class="list_item_icon">
                    <img src="@/assets/images/2.png" draggable="false" />
                  </div>
                  <div class="list_item_title">室内3D地图建模及导航和控制系统</div>
                  <div class="list_item_info">
                    通过自主研发的激光雷达系统和导航定位算法，集成机器视觉、通讯模组、信号控制系统等，融合人员动态特征分析体系，实现对室内人、物、环境等元素精准建模，对设施设备进行状态调解，提供各类定制化服务。
                  </div>
                </div>
                <div class="list_item">
                  <div class="list_item_icon">
                    <img src="@/assets/images/3.png" draggable="false" />
                  </div>
                  <div class="list_item_title">工业互联网与生产线智能化系统</div>
                  <div class="list_item_info">
                    通过数据采集和数据分析以及SaaS软件构建一体化生产服务平台，帮助客户实现生产过程可视化、生产流程分析与优化，并通过机器智能化设计实现对生产设备的智能化升级。
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <el-carousel-item @mousedown="mousedown" :style="autoplay?'':'transition: none;'">
              <div class="list">
                <div class="list_item">
                  <div class="list_item_icon">
                    <img src="@/assets/images/x@2x.png" draggable="false" />
                  </div>
                  <div class="list_item_title">生物动态特征提取和大数据分析系统</div>
                  <div class="list_item_info">
                    通过可穿戴设备及毫米波雷达设备，完成对移动生物具体状态实时跟踪，然后通过瞬态信号特征提取、多维信号耦合、信号回归等专利算法对原始数据进行解析，实现对目标生物的精确状态跟踪。
                  </div>
                </div>
                <div class="list_item">
                  <div class="list_item_icon">
                    <img src="@/assets/images/q@2x.png" draggable="false" />
                  </div>
                  <div class="list_item_title">多级互信的区块链应用平台系统</div>
                  <div class="list_item_info">
                    根据不同的业务需求，编写贴合所需应用场景的智能合约，能够为企业通过智能合约构建出执行一定商业逻辑的区块链应用，并能协助企业完成相关硬件产品的开发。
                  </div>
                </div>
                <div class="list_item" style="background: #14171A !important;"></div>
              </div>
            </el-carousel-item>
          </el-carousel>
        </div>
      </div>
      <div class="home_hz_box">
        <div class="home_hz_box_title" style="margin-top: 60px;" ref="dom4">项目图片展示</div>
        <div class="home_hz_box_prd">
          <div class="prd_item">
            <img src="@/assets/images/1@2x.png" />
          </div>
          <div class="prd_item">
            <img src="@/assets/images/2@2x.png" />
          </div>
          <div class="prd_item">
            <img src="@/assets/images/3@2x.png" />
          </div>
          <div class="prd_item">
            <img src="@/assets/images/4@2x.png" />
          </div>
          <div class="prd_item">
            <img src="@/assets/images/5@2x.png" />
          </div>
          <div class="prd_item">
            <img src="@/assets/images/6@2x.png" />
          </div>
          <div class="prd_item">
            <img src="@/assets/images/7@2x.png" />
          </div>
          <div class="prd_item">
            <img src="@/assets/images/8@2x.png" />
          </div>
          <div class="prd_item">
            <img src="@/assets/images/9@2x.png" />
          </div>
        </div>
      </div>
    </div>
    <!--  技术专家团队  -->
    <div class="home_hz" style="background: #14171A;">
      <div class="home_hz_box" ref="dom3">
        <div class="home_hz_box_title">技术专家团队</div>
        <div class="home_hz_box_list">
          <el-carousel indicator-position="outside" height="800px" :autoplay="false" ref="carousel1">
            <el-carousel-item @mousedown="mousedown1" :style="autoplay1?'':'transition: none;'">
              <div class="list">
                <div class="list_item1">
                  <div class="list_item_name">
                    李伟凯
                  </div>
                  <div class="list_item_title">博士 副教授</div>
                  <div class="list_item_info">
                    南京航空航天大学博士；山东建筑大学副教授、硕士生导师；
                    主研省部级项目4项；主研国家自然科学基金项目1项。
                    在《IEEE Transactions on Pattern Analysis and Machine Intelligence》 《Pattern Recognition》《IEEE Journal of Biomedical and Health Informatics》和《Human Brain Mapping》等国际期刊发表SCI检索论文23篇。
                    研究方向：机器视觉与识别模式
                  </div>
                </div>
                <div class="list_item1">
                  <div class="list_item_name">
                    赵鹏兵
                  </div>
                  <div class="list_item_title">教授 博士生导师</div>
                  <div class="list_item_info">
                    高性能电子装备机电集成制造全国重点实验室核心成员。
                    2014年9月毕业于西北工业大学机械电子工程专业，获工学博士学位；2011年9月~2013年9月，受“国家建设高水平大学公派研究生项目”资助，在加拿大Concordia University工程与计算机科学学院从事高档数控机床与智能工业机器人动力学及控制等方面的研究；2014年10月至今，任教于西安电子科技大学机电工程学院。2019年3月~2020年3月，在国家科技部办公厅挂职锻炼。
                  </div>
                </div>
                <div class="list_item1">
                  <div class="list_item_name">
                    李勇
                  </div>
                  <div class="list_item_title">副教授</div>
                  <div class="list_item_info">
                    华东理工大学副教授，机械与动力工程学院系主任，西安交通大学优秀博士毕业生，第五届上银优秀机械博士论文奖提名（全国前30位）。
                    主持国家自然科学基金等项目3项，参与国家科技重大专项、国家重点研发计划等重大项目6项，项目总额近五千万；
                    在机械及信号处理领域国际期刊发表高水平SCI论文十余篇，申请授权国家发明专利5项。
                    并担任Measurement，Engineering Structures, International Journal of Advanced Manufacturing Technology, Sensors等国际期刊的同行审稿人。
                  </div>
                </div>
              </div>
            </el-carousel-item>
            <!-- <el-carousel-item @mousedown="mousedown1" :style="autoplay1?'':'transition: none;'">
              <div class="list">
                <div class="list_item1">
                  <div class="list_item_name">
                    李勇
                  </div>
                  <div class="list_item_title">副教授</div>
                  <div class="list_item_info">
                    华东理工大学副教授，机械与动力工程学院系主任，西安交通大学优秀博士毕业生，第五届上银优秀机械博士论文奖提名（全国前30位）。
                  </div>
                </div>
                <div class="list_item1" style="background: #14171A !important;"></div>
              </div>
            </el-carousel-item> -->
          </el-carousel>
        </div>
      </div>
    </div>
    <!--  关于我们  -->
    <div class="home_about">
      <div class="home_about_box" ref="dom5">
        <div class="home_about_box_title">关于我们</div>
        <div class="home_about_box_img">
          <img src="@/assets/images/company.png" />
        </div>
        <div class="home_about_box_info">
          上海澜启信息科技有限公司成立于2017年，是一家专业的人工智能和机器自动化解决方案服务商，本公司拥有动态信号分析、机器视觉、机器人结构部件等自有算法和终端设备，基于loT物理信息技术，通过振动、视频和多类型传感设备来获取原始数据信号，然后通过云计算平台运行的瞬态信号特征提取、多维信号耦合、信号回归等专利算法，辨析及分析出准确的状态指标做出实际场景还原，最后通过自动化控制终端实现对目标对象的精确调整和控制。以瞬态实时，高度准确的数据和柔性精确控制系统满足不同用户和各类应用的场景需求。
        </div>
        <div class="home_about_box_footer">
          <div class="footer_left">
            <span>感谢您的关注！</span>
            <span>我们非常感谢您的信任以及对我们产品的选择</span>
          </div>
          <div class="footer_right">
            <input type="text" placeholder="Email" />
            <el-button type="primary" color="#155FFE" style="width: 150px; height: 72px; border-radius: 8px; font-size: 26px; letter-spacing: 7px;">提交</el-button>
          </div>
        </div>
        <div class="footer">
          <span>©上海澜启信息科技有限公司官方网站</span>
          <span><a href="https://beian.miit.gov.cn/">沪ICP备18011230号-1</a></span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'HomeView',
  data() {
    return {
      i: 0,
      list: [
        { name: '产品介绍', ref: 'dom1' },
        { name: '技术支持', ref: 'dom2' },
        { name: '技术专家', ref: 'dom3' },
        { name: '项目展示', ref: 'dom4' },
        { name: '关于我们', ref: 'dom5' }
      ],
      autoplay: true,
      countX: 0,

      autoplay1: true,
      countX1: 0
    }
  },
  mounted() {
    //添加全局的鼠标滑动鼠标左键抬起
    document.addEventListener("mouseup", this.mouseup)
    document.addEventListener("mousemove", this.mousemove)

    document.addEventListener("mouseup", this.mouseup1)
    document.addEventListener("mousemove", this.mousemove1)
    document.title = '上海澜启信息科技有限公司'
  },
  methods: {
    mousedown1() {
      //鼠标按下时暂停自动轮播，同时清除移动距离
      this.autoplay1 = false
      this.countX1 = 0
    },
    mousemove1(e) {
      //判断是不是鼠标按下状态
      if (this.autoplay1) return
      if (this.autoplay1) return
      //获取全部的轮播图子项
      let list = document.querySelectorAll(".el-carousel__item")
      this.countX1 += e.movementX
      for (let i = 0; i < list.length; i++) {
        //使每一项偏离鼠标移动的距离
        list[i].style.transform =
                `translateX(${parseInt(list[i].style.transform.replace('translateX(',""))+e.movementX}px) scale(1)`
      }
    },
    mouseup1() {
      //判断是不是鼠标按下状态
      if (this.autoplay1) return
      this.autoplay1 = true
      //如果向右边移动超过100就切换上一张
      if (this.countX1 >= 50) {
        this.$refs.carousel1.prev()
      } else if (this.countX1 <= -50) { //如果向左边移动超过100就切换下一张
        this.$refs.carousel1.next()
      } else {
        //否则回到当前
        this.$refs.carousel1.prev()
        this.$refs.carousel1.next()
      }
    },

    mousedown() {
      //鼠标按下时暂停自动轮播，同时清除移动距离
      this.autoplay = false
      this.countX = 0
    },
    mousemove(e) {
      //判断是不是鼠标按下状态
      if (this.autoplay) return
      if (this.autoplay) return
      //获取全部的轮播图子项
      let list = document.querySelectorAll(".el-carousel__item")
      this.countX += e.movementX
      for (let i = 0; i < list.length; i++) {
        //使每一项偏离鼠标移动的距离
        list[i].style.transform =
                `translateX(${parseInt(list[i].style.transform.replace('translateX(',""))+e.movementX}px) scale(1)`
      }
    },
    mouseup() {
      //判断是不是鼠标按下状态
      if (this.autoplay) return
      this.autoplay = true
      //如果向右边移动超过100就切换上一张
      if (this.countX >= 50) {
        this.$refs.carousel.prev()
      } else if (this.countX <= -50) { //如果向左边移动超过100就切换下一张
        this.$refs.carousel.next()
      } else {
        //否则回到当前
        this.$refs.carousel.prev()
        this.$refs.carousel.next()
      }
    },
    clickItem(row, index) {
      this.i = index
      const element = this.$refs[row.ref];
      if (element) {
        // 平滑滚动到元素位置
        window.scrollTo({
          behavior: 'smooth',
          top: element.offsetTop
        });
      }
    }
  }
}
</script>
<style>
  .el-carousel__indicators--outside button {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    background: #D8D8D8;
  }
  .el-carousel__indicator.is-active button {
    background: #155FFE;
  }
  .el-carousel__arrow--left {
    display: none !important;
  }
  .el-carousel__arrow--right {
    display: none !important;
  }
</style>
<style lang="scss" scoped>
  .home {
    width: 100%;
    height: 100%;
    background-image: url("@/assets/images/leftbg.png");
    background-size: 900px 406px;
    background-repeat: no-repeat;
    .home_head {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      .home_head_box {
        width: 1592px;
        height: 100px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .home_head_box_log {
          flex-shrink: 0;
          display: flex;
          align-items: center;
          img {
            width: 30px;
            height: 30px;
            margin-right: 16px;
          }
          span {
            font-weight: 500;
            font-size: 22px;
            color: #FFFFFF;
          }
        }
        .home_head_box_menu {
          display: flex;
          align-items: center;
          .home_head_box_menu_active {
            font-weight: 600 !important;
            color: #155FFE !important;
          }
          .home_head_box_menu_row {
            font-weight: 400;
            font-size: 20px;
            color: #FFFFFF;
            margin-left: 120px;
            cursor: pointer;
          }
        }
      }
    }
    .home_banner {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 40px;
      .home_banner_box {
        width: 1592px;
        display: flex;
        align-items: center;
        justify-content: space-between;
        .home_banner_box_left {
          display: flex;
          flex-direction: column;
          span {
            font-weight: 600;
            font-size: 92px;
            color: #FFFFFF;
          }
        }
        .home_banner_box_right {
          img {
            width: 579px;
            height: 598px;
          }
        }
      }
    }
    .home_product {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 120px;
      .home_product_box {
        width: 1592px;
        display: flex;
        flex-direction: column;
        .title {
          width: 100%;
          text-align: center;
          font-weight: 500;
          font-size: 40px;
          color: #FFFFFF;
        }
        .home_product_box_list {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 90px;
          .item {
            width: 480px;
            height: 740px;
            background: #13213F;
            box-shadow: 0 0 16px 0 rgba(80,80,80,0.5);
            padding: 20px;
            cursor: pointer;
            box-sizing: border-box;
            &:hover {
              background: linear-gradient( 225deg, rgba(172,192,210,0.5) 0%, rgba(67,104,174,0.5) 23%, rgba(55,67,97,0.5) 32%, rgba(150,180,251,0.5) 64%, rgba(20,31,81,0.5) 90%, rgba(15,23,56,0.5) 100%), #13213F;
            }
            .item_box {
              width: 100%;
              height: 100%;
              padding: 20px;
              box-sizing: border-box;
              background: #1F325B;
              .item_box_file {
                width: 100%;
                height: 254px;
                display: flex;
                align-items: center;
                justify-content: center;
                overflow: hidden;
                video {
                  width: 100%;
                }
                img {
                  width: 100%;
                }
              }
              .item_box_title {
                width: 100%;
                display: flex;
                flex-direction: column;
                margin-top: 32px;
                span {
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 1;
                  -webkit-box-orient: vertical;
                  font-weight: 500;
                  font-size: 30px;
                  color: #FFFFFF;
                  margin-bottom: 6px;
                  &:last-child {
                    margin: 0 !important;
                  }
                }
              }
              .item_box_info {
                width: 100%;
                height: 254px;
                margin-top: 28px;
                font-weight: 400;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 36px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-line-clamp: 7;
                -webkit-box-orient: vertical;
              }
            }
          }
        }
      }
    }
    .home_hz {
      width: 100%;
      margin-top: 120px;
      background-repeat: no-repeat;
      background-size: 100% 500px;
      background-position: center center;
      display: flex;
      align-items: center;
      justify-content: center;
      flex-direction: column;
      background-image: url("@/assets/images/background.png");
      .home_hz_box {
        width: 1592px;
        .home_hz_box_title {
          width: 100%;
          text-align: center;
          font-weight: 500;
          font-size: 40px;
          color: #FFFFFF;
        }
        .home_hz_box_prd {
          width: 100%;
          margin-top: 92px;
          display: flex;
          align-items: center;
          justify-content: space-between;
          flex-wrap: wrap;
          .prd_item {
            width: 508px;
            height: 310px;
            display: flex;
            align-items: center;
            justify-content: center;
            overflow: hidden;
            margin-bottom: 60px;
            background: #ececec;
            img {
              width: 100%;
            }
          }
        }
        .home_hz_box_list {
          width: 100%;
          margin-top: 92px;
          .list {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-around;
            .list_item1 {
              width: 480px;
              height: 740px;
              background: #262C32;
              padding: 104px 28px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              &:hover {
                background: #191C1E !important;
              }
              .list_item_name {
                font-weight: 600;
                font-size: 30px;
                color: #155FFE;
                line-height: 42px;
              }
              .list_item_title {
                width: 320px;
                text-align: center;
                font-weight: 500;
                font-size: 30px;
                color: #FFFFFF;
                line-height: 42px;
                margin-top: 74px;
                font-style: normal;
              }
              .list_item_info {
                width: 100%;
                text-align: center;
                font-weight: 400;
                font-size: 14px; /* 这里从 20px 改为 16px */
                color: #FFFFFF;
                line-height: 36px;
                letter-spacing: 4px;
                margin-top: 74px;
              }
            }
            .list_item {
              width: 480px;
              height: 740px;
              background: #262C32;
              padding: 0 28px;
              box-sizing: border-box;
              display: flex;
              flex-direction: column;
              align-items: center;
              justify-content: center;
              &:hover {
                background: #191C1E !important;
              }
              .list_item_icon {
                width: 100px;
                height: 100px;
                display: flex;
                align-items: center;
                justify-content: center;
                img {
                  width: 100%;
                }
              }
              .list_item_title {
                width: 320px;
                text-align: center;
                font-weight: 500;
                font-size: 30px;
                color: #FFFFFF;
                line-height: 42px;
                margin-top: 74px;
                font-style: normal;
              }
              .list_item_info {
                width: 100%;
                text-align: center;
                font-weight: 400;
                font-size: 20px; /* 这个保持不变 */
                color: #FFFFFF;
                line-height: 36px;
                letter-spacing: 4px;
                margin-top: 74px;
              }
            }
          }
        }
      }
    }
    .home_about {
      width: 100%;
      display: flex;
      align-items: center;
      justify-content: center;
      margin-top: 120px;
      .home_about_box {
        width: 1592px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        .home_about_box_title {
          width: 100%;
          text-align: center;
          font-weight: 500;
          font-size: 40px;
          color: #FFFFFF;
          line-height: 56px;
        }
        .home_about_box_img {
          width: 600px;
          height: 436px;
          margin-top: 90px;
          display: flex;
          align-items: center;
          justify-content: center;
          overflow: hidden;
          img {
            width: 100%;
          }
        }
        .home_about_box_info {
          width: 100%;
          font-weight: 400;
          font-size: 26px;
          color: #FFFFFF;
          line-height: 50px;
          letter-spacing: 4px;
          text-align: center;
          margin-top: 90px;
        }
        .home_about_box_footer {
          width: 100%;
          display: flex;
          align-items: center;
          justify-content: space-between;
          margin-top: 120px;
          .footer_left {
            display: flex;
            flex-direction: column;
            span {
              &:nth-child(1) {
                font-weight: 500;
                font-size: 40px;
                color: #FFFFFF;
                line-height: 56px;
              }
              &:nth-child(2) {
                font-weight: 400;
                font-size: 20px;
                color: #FFFFFF;
                line-height: 50px;
                letter-spacing: 2px;
                margin-top: 14px;
              }
            }
          }
          .footer_right {
            display: flex;
            align-items: center;
            input {
              width: 400px;
              height: 64px;
              padding: 0 10px;
              box-sizing: border-box;
              border-radius: 8px;
              border: 2px solid #FFFFFF;
              margin-right: 24px;
              background: #14171a;
              outline: none;
              color: #ffffff;
              font-weight: 400;
              font-size: 20px;
            }
          }
        }
        .footer {
          width: 100%;
          display: flex;
          flex-direction: column;
          align-items: center;
          justify-content: center;
          margin-top: 120px;
          span {
            font-weight: 200;
            font-size: 24px;
            color: rgba(255, 255, 255, 0.5);
            line-height: 36px;
            letter-spacing: 2px;
            margin-bottom: 6px;
            &:last-child {
              margin-bottom: 36px !important;
            }
          }
        }
      }
    }
  }
</style>
